// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SummaryBanner_wrapper__NZfUU","iconWrapper":"SummaryBanner_iconWrapper__9bxdq","text":"SummaryBanner_text__HmDQM"};